export const TRAIN_COMPARE_MODELS = "modelCompare";
export const TRAIN_COMPARE_PARAMETERS = "paramCompare";
export const ANNOTATION_USER_CHOSEN = "chooseID";
export const ANNOTATION_DEFAULT_TASK = "default";

export const miniModeToLabel = {
  [TRAIN_COMPARE_MODELS]: "Train Different Models with Given Parameters",
  [TRAIN_COMPARE_PARAMETERS]: "Train One Model with Different Parameters",
  [ANNOTATION_USER_CHOSEN]: "Process Datasets Using User-Trained Model",
  [ANNOTATION_DEFAULT_TASK]: "Process Datasets Using Predefined Model",
};